export const SOFTWARE_BASE_PRODUCT_KEYS = {
  SW_KIOSK: 'sw-kiosk',
};

// Square hardware-bundle subscription products. The reconciler in
// Cart::UpdateInteractor auto-adds one of these as a Spree::LineItem when the
// cart is eligible. The FE filters them out of the default <ActionableItem>
// loop and represents them through <BundleOfferCard> instead, so the bundle
// has exactly one rendered surface on the cart page.
//
// `sw-square-free` is included for forward compatibility — the reconciler
// only auto-adds plus / premium today, but a user-driven dismiss-to-Free swap
// (SAAS-4858b) will put `sw-square-free` in the cart and the FE filter should
// catch it without code changes.
export const BUNDLE_SQUARE_TIER_BY_BASE_PRODUCT_KEY = Object.freeze({
  'sw-square-free': 'free',
  'sw-square-plus': 'plus',
  'sw-square-premium': 'premium',
});

export const BUNDLE_SQUARE_BASE_PRODUCT_KEYS = Object.freeze(
  Object.keys(BUNDLE_SQUARE_TIER_BY_BASE_PRODUCT_KEY),
);

// `hardware_bundle_offer.experiment_variation` values emitted by
// Solidshop::LaunchDarkly::Experiments::SaasShopHardwareBundleExperiment.
export const HARDWARE_BUNDLE_EXPERIMENT_VARIATIONS = Object.freeze({
  CONTROL: 'control',
  OPT_IN: 'opt_in',
  OPT_OUT: 'opt_out',
});

// Possible `hardware_bundle_offer.resolution` values emitted by
// Solidshop::Software::HardwareBundleOfferViewModel. `suppress` never actually
// appears in JSON today (BE returns nil payload when the resolver suppresses),
// but the FE guards against it defensively.
export const BUNDLE_OFFER_RESOLUTIONS = Object.freeze({
  PLUS: 'plus',
  PREMIUM: 'premium',
  UPGRADE_TO_PREMIUM: 'upgrade_to_premium',
  UPGRADE_IN_CART: 'upgrade_in_cart',
  INELIGIBLE_TO_MIGRATE: 'ineligible_to_migrate',
  ALREADY_SUBSCRIBED: 'already_subscribed',
  SUPPRESS: 'suppress',
});
